module.exports = __webpack_public_path__ + "d2021239ca2af45e6e4a6f0aa9d6ea95.png";